(function () {
  var config = window.KartologPokeballHunt || {};
  var apiBase = config.apiBase || '/apps/takas/pokeball-hunt-api';
  var collectApiBase = config.collectApiBase || '/apps/takas/pokeball-collect-api';
  var iconUrl = config.iconUrl || '';
  var customerEmail = config.customerEmail || '';
  var storageKey = 'kartolog:pokeball-hunt:visitor';
  var claimedKeyPrefix = 'kartolog:pokeball-hunt:claimed:';
  var collectPollTimer = null;
  var activeButton = null;

  function visitorId() {
    try {
      var existing = window.localStorage.getItem(storageKey);
      if (existing) return existing;
      var next = 'v_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 12);
      window.localStorage.setItem(storageKey, next);
      return next;
    } catch (_error) {
      return 'v_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 12);
    }
  }

  function todayKey() {
    return new Date().toISOString().slice(0, 10);
  }

  function alreadyClaimedToday() {
    try {
      return window.localStorage.getItem(claimedKeyPrefix + todayKey()) === '1';
    } catch (_error) {
      return false;
    }
  }

  function markClaimedToday() {
    try {
      window.localStorage.setItem(claimedKeyPrefix + todayKey(), '1');
    } catch (_error) {}
  }

  function injectStyles() {
    if (document.getElementById('kartolog-pokeball-hunt-style')) return;
    var style = document.createElement('style');
    style.id = 'kartolog-pokeball-hunt-style';
    style.textContent = [
      '.kartolog-pokeball-hunt{position:fixed;z-index:2147483000;width:46px;height:46px;border:0;background:transparent;padding:0;cursor:pointer;filter:drop-shadow(0 10px 18px rgba(255,62,39,.28));animation:kartologPokeballFloat 2.4s ease-in-out infinite;}',
      '.kartolog-pokeball-hunt img{display:block;width:100%;height:100%;object-fit:contain;transition:transform .18s ease;}',
      '.kartolog-pokeball-hunt:hover img{transform:scale(1.12) rotate(-8deg);}',
      '.kartolog-pokeball-hunt[disabled]{pointer-events:none;opacity:.75;}',
      '.kartolog-pokeball-collect-layer{position:absolute;left:0;top:0;width:100%;height:100%;z-index:2147482998;pointer-events:none;}',
      '.kartolog-pokeball-collect{position:absolute;width:34px;height:34px;border:0;background:transparent;padding:0;cursor:pointer;filter:drop-shadow(0 8px 14px rgba(17,24,39,.22));pointer-events:auto;}',
      '.kartolog-pokeball-collect--embedded{z-index:9;}',
      '.kartolog-pokeball-collect img{display:block;width:100%;height:100%;object-fit:contain;transition:transform .16s ease,opacity .16s ease;}',
      '.kartolog-pokeball-collect:hover img{transform:scale(1.14) rotate(9deg);}',
      '.kartolog-pokeball-collect[disabled] img{opacity:.45;transform:scale(.72);}',
      '.kartolog-pokeball-collect-count{position:fixed;right:14px;bottom:14px;z-index:2147482999;display:flex;align-items:center;gap:8px;min-height:38px;padding:7px 12px;border:1px solid rgba(17,24,39,.12);border-radius:999px;background:#fff;color:#111827;font:700 13px/1 Jost,Arial,sans-serif;box-shadow:0 12px 30px rgba(15,23,42,.14);}',
      '.kartolog-pokeball-collect-count img{width:22px;height:22px;object-fit:contain;}',
      '@keyframes kartologPokeballFloat{0%,100%{transform:translate3d(0,0,0)}50%{transform:translate3d(0,-7px,0)}}',
      '@keyframes kartologPokeballPeek{0%,100%{transform:translate3d(0,0,0) rotate(-2deg)}50%{transform:translate3d(0,-4px,0) rotate(4deg)}}',
      '.kartolog-pokeball-modal-backdrop{position:fixed;inset:0;z-index:2147483001;background:rgba(10,16,28,.42);display:flex;align-items:center;justify-content:center;padding:20px;}',
      '.kartolog-pokeball-modal{width:min(420px,100%);background:#fff;border:1px solid #111827;border-radius:14px;box-shadow:0 24px 80px rgba(15,23,42,.28);font-family:Jost,Arial,sans-serif;color:#111827;overflow:hidden;}',
      '.kartolog-pokeball-modal__head{padding:22px 22px 12px;display:flex;gap:14px;align-items:center;}',
      '.kartolog-pokeball-modal__icon{width:52px;height:52px;object-fit:contain;flex:0 0 auto;}',
      '.kartolog-pokeball-modal h2{font-size:24px;line-height:1.1;margin:0;font-weight:700;letter-spacing:0;}',
      '.kartolog-pokeball-modal p{margin:7px 0 0;font-size:14px;line-height:1.45;color:#4b5563;}',
      '.kartolog-pokeball-code{margin:14px 22px 0;padding:14px 16px;border:1px dashed #ff3e27;border-radius:10px;background:#fff7f4;color:#111827;font-size:24px;font-weight:800;letter-spacing:.08em;text-align:center;}',
      '.kartolog-pokeball-modal__actions{display:grid;grid-template-columns:1fr 1fr;gap:10px;padding:18px 22px 22px;}',
      '.kartolog-pokeball-modal button,.kartolog-pokeball-modal a{height:44px;border:1px solid #111827;border-radius:8px;background:#fff;color:#111827;font:700 14px/44px Jost,Arial,sans-serif;text-align:center;text-decoration:none;cursor:pointer;}',
      '.kartolog-pokeball-modal .primary{border-color:#ff3e27;background:#ff3e27;color:#fff;}',
      '.kartolog-pokeball-toast{position:fixed;left:50%;bottom:22px;transform:translateX(-50%);z-index:2147483002;max-width:min(440px,calc(100vw - 28px));padding:13px 16px;border-radius:10px;background:#111827;color:#fff;font:600 14px/1.35 Jost,Arial,sans-serif;box-shadow:0 16px 40px rgba(15,23,42,.28);}',
      '@media(max-width:749px){.kartolog-pokeball-hunt{width:40px;height:40px}.kartolog-pokeball-collect{width:30px;height:30px}.kartolog-pokeball-modal__actions{grid-template-columns:1fr}.kartolog-pokeball-code{font-size:20px}}',
    ].join('');
    document.head.appendChild(style);
  }

  function showToast(message) {
    var toast = document.createElement('div');
    toast.className = 'kartolog-pokeball-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    window.setTimeout(function () {
      toast.remove();
    }, 3600);
  }

  function showModal(payload) {
    var backdrop = document.createElement('div');
    backdrop.className = 'kartolog-pokeball-modal-backdrop';
    var code = payload.code || '';
    backdrop.innerHTML =
      '<div class="kartolog-pokeball-modal" role="dialog" aria-modal="true" aria-label="Kartolog indirim kodu">' +
      '<div class="kartolog-pokeball-modal__head">' +
      (iconUrl ? '<img class="kartolog-pokeball-modal__icon" alt="" src="' + iconUrl + '">' : '') +
      '<div><h2>Kartoball bulundu!</h2><p>' + (payload.message || 'Indirim kodun hazir.') + ' Kod tek kullanimliktir.</p></div>' +
      '</div>' +
      '<div class="kartolog-pokeball-code">' + code + '</div>' +
      '<div class="kartolog-pokeball-modal__actions">' +
      '<button class="primary" type="button" data-copy>Kodu kopyala</button>' +
      '<a href="/cart">Sepete git</a>' +
      '</div>' +
      '</div>';
    backdrop.addEventListener('click', function (event) {
      if (event.target === backdrop) backdrop.remove();
    });
    var copyButton = backdrop.querySelector('[data-copy]');
    copyButton.addEventListener('click', function () {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          showToast('Kod kopyalandi.');
        }).catch(function () {
          showToast('Kod: ' + code);
        });
      } else {
        showToast('Kod: ' + code);
      }
    });
    document.body.appendChild(backdrop);
  }

  function spawnPokeball(spawn) {
    if (!spawn || !spawn.show || !spawn.spawnId || activeButton || !iconUrl) return;
    injectStyles();
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'kartolog-pokeball-hunt';
    button.setAttribute('aria-label', 'Gizli Kartoball yakala');
    button.style.top = Math.max(8, Math.min(84, Number(spawn.position && spawn.position.top) || 42)) + 'vh';
    button.style.left = Math.max(4, Math.min(90, Number(spawn.position && spawn.position.left) || 50)) + 'vw';
    button.innerHTML = '<img alt="" src="' + iconUrl + '">';
    button.addEventListener('click', function () {
      if (button.disabled) return;
      button.disabled = true;
      claimPokeball(spawn.spawnId).then(function (payload) {
        activeButton = null;
        button.remove();
        markClaimedToday();
        showModal(payload);
      }).catch(function (error) {
        activeButton = null;
        button.remove();
        showToast(error.message || 'Kartoball odulu alinamadi.');
      });
    });
    activeButton = button;
    document.body.appendChild(button);
  }

  function claimPokeball(spawnId) {
    return fetch(apiBase + '/claim?spawnId=' + encodeURIComponent(spawnId) + '&visitorId=' + encodeURIComponent(visitorId()) + '&page=' + encodeURIComponent(currentPageKey()), {
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function (response) {
      return response.json().catch(function () {
        return { ok: false, error: 'Sunucu yaniti okunamadi. HTTP ' + response.status + '.' };
      }).then(function (payload) {
        if (!response.ok || !payload.ok) throw new Error(payload.error || 'Kartoball odulu alinamadi.');
        return payload;
      });
    });
  }

  function updateCollectCounter(balance) {
    if (!iconUrl || typeof balance === 'undefined') return;
    injectStyles();
    var counter = document.querySelector('.kartolog-pokeball-collect-count');
    if (!counter) {
      counter = document.createElement('div');
      counter.className = 'kartolog-pokeball-collect-count';
      counter.innerHTML = '<img alt="" src="' + iconUrl + '"><span></span>';
      document.body.appendChild(counter);
    }
    counter.querySelector('span').textContent = String(balance) + ' Kartoball';
  }

  function spawnCollectBalls(payload) {
    if (!payload || !payload.ok || !Array.isArray(payload.balls) || !iconUrl) return;
    updateCollectCounter(payload.balance);
    payload.balls.forEach(function (ball) {
      if (!ball || !ball.id || document.querySelector('[data-kartolog-collect-id="' + ball.id + '"]')) return;
      injectStyles();
      var button = document.createElement('button');
      var topPercent = Math.max(8, Math.min(92, Number(ball.position && ball.position.top) || 50));
      var leftPercent = Math.max(4, Math.min(92, Number(ball.position && ball.position.left) || 50));
      button.type = 'button';
      button.className = 'kartolog-pokeball-collect';
      button.dataset.kartologCollectId = ball.id;
      button.setAttribute('aria-label', 'Sakli Kartoball topla');
      button.innerHTML = '<img alt="" src="' + iconUrl + '">';
      button.addEventListener('click', function () {
        if (button.disabled) return;
        button.disabled = true;
        claimCollectBall(ball.id).then(function (result) {
          button.remove();
          updateCollectCounter(result.balance);
          showToast(result.message || '+1 Kartoball toplandi.');
        }).catch(function (error) {
          button.disabled = false;
          showToast(error.message || 'Kartoball toplanamadi.');
        });
      });
      placeCollectBall(button, ball, topPercent, leftPercent);
    });
  }

  function placeCollectBall(button, ball, topPercent, leftPercent) {
    var target = collectPlacementTarget(ball);
    if (target) {
      button.classList.add('kartolog-pokeball-collect--embedded');
      ensurePositioned(target);
      button.style.top = collectTargetTop(target, topPercent) + 'px';
      button.style.left = collectTargetLeft(target, leftPercent) + 'px';
      target.appendChild(button);
      return;
    }
    var layer = collectLayer();
    button.style.top = collectTopPx(topPercent) + 'px';
    button.style.left = collectLeftPx(leftPercent) + 'px';
    layer.appendChild(button);
  }

  function collectPlacementTarget(ball) {
    var selectors = [
      '.product-grid .grid__item',
      '.collection .grid__item',
      '.grid.product-grid .grid__item',
      '.product-card-wrapper',
      '.card-wrapper',
      '.pagination-wrapper',
      '.facets-wrapper',
      'main .shopify-section',
      '[id^="shopify-section-"]',
      'main section',
      'main'
    ];
    for (var i = 0; i < selectors.length; i += 1) {
      var nodes = Array.prototype.slice.call(document.querySelectorAll(selectors[i])).filter(isVisibleTarget);
      if (!nodes.length) continue;
      return nodes[hashString(String(ball.id) + ':' + selectors[i]) % nodes.length];
    }
    return null;
  }

  function isVisibleTarget(node) {
    if (!node || !node.getBoundingClientRect) return false;
    var rect = node.getBoundingClientRect();
    return rect.width >= 48 && rect.height >= 48;
  }

  function ensurePositioned(node) {
    var current = window.getComputedStyle(node).position;
    if (!current || current === 'static') node.style.position = 'relative';
  }

  function collectTargetTop(target, percent) {
    var height = Math.max(48, Math.round(target.getBoundingClientRect().height || 0));
    var raw = Math.round((Math.max(8, Math.min(82, Number(percent) || 30)) / 100) * height);
    return Math.max(6, Math.min(height - 38, raw));
  }

  function collectTargetLeft(target, percent) {
    var width = Math.max(48, Math.round(target.getBoundingClientRect().width || 0));
    var raw = Math.round((Math.max(8, Math.min(82, Number(percent) || 70)) / 100) * width);
    return Math.max(6, Math.min(width - 38, raw));
  }

  function hashString(value) {
    var hash = 0;
    for (var i = 0; i < value.length; i += 1) {
      hash = ((hash << 5) - hash + value.charCodeAt(i)) | 0;
    }
    return Math.abs(hash);
  }

  function collectLayer() {
    injectStyles();
    var layer = document.querySelector('.kartolog-pokeball-collect-layer');
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'kartolog-pokeball-collect-layer';
      document.body.appendChild(layer);
    }
    updateCollectLayerBounds(layer);
    return layer;
  }

  function updateCollectLayerBounds(layer) {
    var target = layer || document.querySelector('.kartolog-pokeball-collect-layer');
    if (!target) return;
    var pageHeight = Math.max(
      document.documentElement.scrollHeight || 0,
      document.body.scrollHeight || 0,
      window.innerHeight || 0
    );
    var pageWidth = Math.max(
      document.documentElement.scrollWidth || 0,
      document.body.scrollWidth || 0,
      window.innerWidth || 0
    );
    target.style.height = pageHeight + 'px';
    target.style.width = pageWidth + 'px';
  }

  function collectTopPx(percent) {
    var pageHeight = Math.max(
      document.documentElement.scrollHeight || 0,
      document.body.scrollHeight || 0,
      window.innerHeight || 0
    );
    var safeHeight = Math.max(window.innerHeight || 0, pageHeight - 80);
    return Math.round((Math.max(4, Math.min(96, Number(percent) || 50)) / 100) * safeHeight);
  }

  function collectLeftPx(percent) {
    var pageWidth = Math.max(
      document.documentElement.scrollWidth || 0,
      document.body.scrollWidth || 0,
      window.innerWidth || 0
    );
    var safeWidth = Math.max(320, pageWidth - 46);
    return Math.round((Math.max(2, Math.min(96, Number(percent) || 50)) / 100) * safeWidth);
  }

  function scheduleCollectPoll(ms) {
    if (collectPollTimer) window.clearTimeout(collectPollTimer);
    var delay = Number(ms);
    if (!Number.isFinite(delay) || delay <= 0) delay = 5 * 60 * 1000;
    delay = Math.max(30 * 1000, Math.min(10 * 60 * 1000, delay));
    collectPollTimer = window.setTimeout(initCollect, delay);
  }

  function claimCollectBall(spotId) {
    return fetch(collectApiBase + '/claim?spotId=' + encodeURIComponent(spotId) + '&page=' + encodeURIComponent(currentPageKey()), {
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function (response) {
      return response.json().catch(function () {
        return { ok: false, error: 'Sunucu yaniti okunamadi. HTTP ' + response.status + '.' };
      }).then(function (payload) {
        if (!response.ok || !payload.ok) throw new Error(payload.error || 'Kartoball toplanamadi.');
        return payload;
      });
    });
  }

  function initCollect() {
    if (!customerEmail) return;
    fetch(collectApiBase + '/daily?page=' + encodeURIComponent(currentPageKey()), {
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (payload) {
      spawnCollectBalls(payload);
      scheduleCollectPoll(payload && payload.nextCheckInMs);
    }).catch(function () {
      scheduleCollectPoll(5 * 60 * 1000);
    });
  }

  function initHunt() {
    if (alreadyClaimedToday()) return;
    fetch(apiBase + '/spawn?page=' + encodeURIComponent(currentPageKey()) + '&visitorId=' + encodeURIComponent(visitorId()) + '&customerEmail=' + encodeURIComponent(customerEmail), {
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (payload) {
      if (payload && payload.ok && payload.show) spawnPokeball(payload);
    }).catch(function () {});
  }

  function currentPageKey() {
    var path = window.location.pathname || '/';
    var params = new URLSearchParams(window.location.search || '');
    var page = params.get('page');
    if (page && /^\/collections\//.test(path)) {
      return path.replace(/\/$/, '') + '?page=' + page;
    }
    return path + window.location.search;
  }

  function init() {
    initHunt();
    initCollect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
